/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable multiline-ternary */
/* eslint-disable no-cond-assign */

'use client'

import { useState, useEffect } from 'react'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import styles from './quick-link2.module.scss'
import QuickLinkList from './quick-link-list'
import QuickLinkButton from './quick-link-button'

type QuickLinkWrapperProps = {
  quickLinkLabels?: string[]
  quickLinkSectionIds?: string[]
  updateIsSticky: (isSticky: boolean) => void
  quickLinksRef: any
  segmentEventCommonProperties: any
  windowWidth: number
}

const QuickLinkWrapper = ({
  quickLinkLabels = [],
  quickLinkSectionIds = [],
  updateIsSticky,
  quickLinksRef,
  segmentEventCommonProperties,
  windowWidth,
}: QuickLinkWrapperProps) => {
  const [isToggle, setIsToggle] = useState(false)
  const [isSticky, setIsSticky] = useState(false)
  const [quickLinksSection, setQuickLinksSection] = useState<any>(null)
  const [showDropdown, setShowDropdown] = useState(false)
  const [activeSectionId, setActiveSectionId] = useState<string | null>(null)
  const [selectedListItem, setSelectedListItem] = useState('')

  // dropdown hidden based on user clicks
  useEffect(() => {
    const handleClickOutside = event => {
      if (quickLinksRef.current && !quickLinksRef.current.contains(event.target) && isToggle) {
        setIsToggle(false)
      }
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [isToggle])

  useEffect(() => {
    const handleScroll = () => {
      if (!quickLinksSection) return

      const sectionTop = quickLinksSection.offsetTop
      const sectionHeight = quickLinksSection.offsetHeight
      const scrollPosition = window.scrollY
      const scrollDistance = scrollPosition - sectionTop
      const scrollPercentage = (scrollDistance / sectionHeight) * 100

      setIsSticky(scrollPercentage >= 100)

      let adjustedScrollPosition = scrollPosition

      if (isSticky) {
        setIsToggle(false)
        adjustedScrollPosition -= sectionHeight
      }

      const visibleSectionId =
        quickLinkSectionIds
          .map(id => {
            const element = document.getElementById(id)
            if (element) {
              const elementTop = element.offsetTop - 180
              const elementHeight = element.offsetHeight + 80
              if (adjustedScrollPosition >= elementTop && adjustedScrollPosition < elementTop + elementHeight) {
                setSelectedListItem(id.toUpperCase())
                return id
              }
            }
            return null
          })
          .find((id): id is string => id !== null) ?? null

      setActiveSectionId(visibleSectionId)
    }

    const sectionElement = document.getElementById('quickLinksSection')
    if (sectionElement) {
      setQuickLinksSection(sectionElement)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [quickLinksSection, isSticky])

  const handleSeeMoreClick = (text: string, isSticky: boolean) => {
    setIsToggle(!isToggle)
    setShowDropdown(false)

    if (text === 'showLess' && !isSticky) {
      const quickLinksSection = document.getElementById('quickLinksSection')
      if (quickLinksSection) {
        quickLinksSection.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <div className={`${styles.quickLink} ${isSticky ? styles.sticky : ''} ${isSticky ? styles.stickyLink : ''}`}>
      <h2 className={`${styles.heading} ${styles.mobileHeading}`}>
        <Image
          src={`${assetLoader()}/images/quick-links-icon/LINKS.svg`}
          width={48}
          height={48}
          alt="LINKs icon"
          loading="lazy"
          decoding="async"
        />
        Quick Links
      </h2>
      {/* for mobile sticky quick link */}
      <ul className={styles.mobileHeadingLi}>
        <li
          onClick={() => {
            setShowDropdown(!showDropdown)
            updateIsSticky(!showDropdown)
          }}
          className={`${styles.liLink}`}>
          {selectedListItem}
          <div>
            {showDropdown ? (
              <Image
                src={`${assetLoader()}/images/quick-links-icon/down.svg`}
                className={styles.dropdownBtn}
                alt="dropdown button"
                width={10}
                height={8}
                loading="lazy"
                decoding="async"
              />
            ) : (
              <Image
                src={`${assetLoader()}/images/quick-links-icon/up.svg`}
                className={styles.dropdownBtn}
                alt="dropdown button"
                width={10}
                height={8}
                loading="lazy"
                decoding="async"
              />
            )}
          </div>
        </li>
      </ul>
      <QuickLinkList
        quickLinkLabels={quickLinkLabels}
        isToggle={isToggle}
        showDropdown={showDropdown}
        setShowDropdown={setShowDropdown}
        isSticky={isSticky}
        activeSectionId={activeSectionId}
        setIsToggle={setIsToggle}
        setSelectedListItem={setSelectedListItem}
        segmentEventCommonProperties={segmentEventCommonProperties}
        windowWidth={windowWidth}
      />
      <QuickLinkButton isToggle={isToggle} handleSeeMoreClick={handleSeeMoreClick} isSticky={isSticky} />
    </div>
  )
}

export default QuickLinkWrapper
